<div
  class="container"
  (contextmenu)="onRightClick($event)">
  <!-- view only -->
  @if (showAngularTextarea) {
    <div
      class="angular-editor-textarea p"
      [innerHTML]="item.content?.['text'] || item.content?.['html'] || item.content | pure: cutOutNbsp"></div>
  }
  @if (showAdditionalEditOptions && item) {
    @if (item.type === 'editor') {
      <div class="background-color-picker">
        <coin-v2-checkbox
          [label]="'Highlighted'"
          [(ngModel)]="item.isHighlighted"></coin-v2-checkbox>
      </div>
    }
    <div class="background-color-picker">
      <coin-color-picker [(ngModel)]="item.backgroundColor"></coin-color-picker>
    </div>
    <div class="background-color-picker">
      <coin-color-picker
        [disabled]="item.isHighlighted"
        [isTextColorPicker]="true"
        [(ngModel)]="item.textColor"></coin-color-picker>
    </div>
    <coin-email-slider
      label="Space-Top"
      [(ngModel)]="item.paddingTop"></coin-email-slider>
    <coin-email-slider
      label="Space-Bottom"
      [(ngModel)]="item.paddingBottom"></coin-email-slider>
  }
  @if (showContentEditor) {
    <editor
      licenseKey="gpl"
      [init]="tinyMceSimpleQuillConfig"
      [formControl]="quillFormControl"></editor>
  }
  @if (showTextEditor) {
    <editor
      licenseKey="gpl"
      [init]="tinyMceSimpleQuillConfig"
      [formControl]="quillFormControl"></editor>
  }
  @if (showContentTextEditor) {
    <editor
      licenseKey="gpl"
      [init]="tinyMceAdvancedQuillConfig"
      [formControl]="quillFormControl"></editor>
  }
  @if (showContentTextHtml) {
    <editor
      licenseKey="gpl"
      [init]="tinyMceAdvancedQuillConfig"
      [formControl]="quillFormControl"></editor>
  }

  @if (showAngularHtmlEditor) {
    <editor
      licenseKey="gpl"
      [init]="tinyMceTableEditorConfig"
      [(ngModel)]="item.content['html']"></editor>
  }
  @if (showFaqTableTextEditor) {
    <editor
      licenseKey="gpl"
      [init]="tinyMceTableEditorConfig"
      [(ngModel)]="item.text"></editor>
  }

  <!-- opens at right click -->
  @if (contextMenuVisible) {
    <coin-contextmenu
      #contextMenu
      [x]="contextmenuX"
      [y]="contextmenuY"
      [contextMenuReplacements]="contextMenuReplacements"
      (addItemToContent)="addItemToCursor($event)"
      (close)="contextMenuVisible = false"></coin-contextmenu>
  }
</div>
